import { DashboardActionType } from '@modules/dashboard/store/dashboardActionType';
import { dashboardInitialState } from '@modules/dashboard/store/dashboardInitialState';
import {
  DashboardAction,
  DashboardState,
} from '@modules/dashboard/store/types';

export function dashboardReducer(
  state: DashboardState,
  action: DashboardAction,
): DashboardState {
  const { type } = action;
  switch (type) {
    case DashboardActionType.INIT_QUERY:
      return {
        ...state,
        query: {
          ...state.query,
          ...action.payload,
        },
      };

    case DashboardActionType.SET_VISUAL:
      return {
        ...state,
        visual: {
          ...state.visual,
          ...action.payload,
        },
      };

    case DashboardActionType.SET_QUERY:
      return {
        ...state,
        query: {
          ...state.query,
          ...action.payload,
        },
      };

    case DashboardActionType.SET_LOADING_ANALYSES_BY_ID:
      return {
        ...state,
        visual: {
          ...state.visual,
          loadingAnalysesByID: {
            ...state.visual.loadingAnalysesByID,
            ...action.payload,
          },
        },
      };

    case DashboardActionType.SET_DASHBOARD:
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          ...action.payload,
        },
      };

    case DashboardActionType.SET_METADATA:
      return {
        ...state,
        metadata: {
          layout: { ...state.metadata.layout, ...action.payload.layout },
          analysesMetadata:
            action.payload.analysesMetadata ?? state.metadata.analysesMetadata,
        },
      };

    case DashboardActionType.RESET:
      return {
        ...dashboardInitialState,
      };

    default:
      return state;
  }
}
